import Header from '../Header';
import Footer from '../Footer';
import Meta from '../Meta';
import { pageSEO } from '../../data/SEO';

export default function Layout({
	children,
	pageName,
	style,
	homePagePath = '/',
	pricingPagePath = '/pricing-plans',
	clientFeedbacksPagePath = '/client-feedbacks',
}) {
	return (
		<div className="wrapper" style={style}>
			<Meta {...pageSEO(pageName)} />

			<Header
				homePagePath={homePagePath}
				pricingPagePath={pricingPagePath}
				clientFeedbacksPagePath={clientFeedbacksPagePath}
			/>

			<main>{children}</main>

			<Footer />
		</div>
	);
}
